import UnlikedIcon from "@/common/images/icons/unliked.svg?react";
import SoundOnIcon from "@/common/images/icons/soundOnIcon.svg?react";
import SoundOffIcon from "@/common/images/icons/soundOffIcon.svg?react";
import { LikeIcon } from "@/components/UI/LikeIcon";
import "./LikeSoundOverlay.scss";

interface ILikeSoundOverlayProps {
  gifId?: string;
}

export const LikeSoundOverlay = ({ gifId }: ILikeSoundOverlayProps) => {
  return (
    <div className="LikeSoundOverlay">
      <span className="liked"><LikeIcon idPrefix={gifId} /></span>
      <span className="unliked"><UnlikedIcon /></span>
      <span className="soundOn"><SoundOnIcon /></span>
      <span className="soundOff"><SoundOffIcon /></span>
    </div>
  );
};
